import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const WaterSupplyPumpStationTableDataAPI = createAsyncThunk("WaterSupplyPumpStationTableData", async ({ data }) => {
    const {
        M_WS_PumpStationID,
        token,
        FromTop,
        ToTop,
        M_WardID,
        PumpStation,
        M_UserID,
        DashProjectTypeId,
        RoleID,
        handleWaterSupplyPumpStationExport
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/Master/Get_WEB_M_Distri_WS_PumpStation_Select?M_Distri_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&PumpStation=${PumpStation ? PumpStation : ''}&M_UserID=${M_UserID}&From=${FromTop}&To=${ToTop}`
    } else {
        url = `${BaseUrl}/Master/Get_WEB_M_WS_PumpStation_Select?M_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&PumpStation=${PumpStation ? PumpStation : ''}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleWaterSupplyPumpStationExport && handleWaterSupplyPumpStationExport()
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyPumpStationTableDataSlice = createSlice({
    name: "WaterSupplyPumpStationTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPumpStationTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterSupplyPumpStationTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyPumpStationTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyPumpStationTableDataReducer = WaterSupplyPumpStationTableDataSlice.reducer


export const WaterSupplyPumpStationExportTableDataAPI = createAsyncThunk("WaterSupplyPumpStationExportTableData", async ({ data }) => {
    const {
        M_WS_PumpStationID,
        token,
        FromTop,
        ToTop,
        M_WardID,
        PumpStation,
        M_UserID,
        DashProjectTypeId,
        RoleID
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/Master/Get_WEB_M_Distri_WS_PumpStation_Select?M_Distri_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&PumpStation=${PumpStation ? PumpStation : ''}&M_UserID=${M_UserID}&From=${FromTop}&To=${ToTop}`
    } else {
        url = `${BaseUrl}/Master/Get_WEB_M_WS_PumpStation_Select?M_WS_PumpStationID=${M_WS_PumpStationID ? M_WS_PumpStationID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&PumpStation=${PumpStation ? PumpStation : ''}&M_UserID=${M_UserID}&FromTop=${FromTop}&ToTop=${ToTop}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const WaterSupplyPumpStationExportTableDataSlice = createSlice({
    name: "WaterSupplyPumpStationExportTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPumpStationExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WaterSupplyPumpStationExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WaterSupplyPumpStationExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyPumpStationExportTableDataReducer = WaterSupplyPumpStationExportTableDataSlice.reducer


// InsertUpdate Table Data

export const WaterSupplyPumpStationPostDataAPI = createAsyncThunk("WaterSupplyPumpStationPostData", async ({ data }) => {
    const {
        M_WS_PumpStationID,
        M_Distri_WS_PumpStationID,
        M_WardID,
        PumpStation,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        // handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        RoleID
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("M_Distri_WS_PumpStationID", M_Distri_WS_PumpStationID);
    } else {
        formdata.append("M_WS_PumpStationID", M_WS_PumpStationID);
    }

    formdata.append("M_WardID", M_WardID);
    formdata.append("PumpStation", PumpStation);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);


    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/Master/Post_WEB_M_Distri_WS_PumpStation_InsertUpdate`
    } else {
        url = `${BaseUrl}/Master/Post_WEB_M_WS_PumpStation_InsertUpdate`
    }
    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                handleOnCloseClick()
                toastErrorr(result.message)
            }

            return result
        })
})

const WaterSupplyPumpStationPostDataSlice = createSlice({
    name: "WaterSupplyPumpStationPostData",
    initialState: {
        isPostLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPumpStationPostDataAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(WaterSupplyPumpStationPostDataAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterSupplyPumpStationPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyPumpStationPostDataReducer = WaterSupplyPumpStationPostDataSlice.reducer

// // Delete Table Data

export const WaterSupplyPumpStationMasterDeleteAPI = createAsyncThunk("WaterSupplyPumpStationMasterDelete", async ({ data }) => {

    const {
        M_WS_PumpStationID,
        M_UserID,
        handleIsPost,
        token,
        DashProjectTypeId,
        M_Distri_WS_PumpStationID,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("M_Distri_WS_PumpStationID", M_Distri_WS_PumpStationID);
    } else {
        formdata.append("M_WS_PumpStationID", M_WS_PumpStationID);
    }

    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/Master/WEB_M_Distri_WS_PumpStation_Delete`
    } else {
        url = `${BaseUrl}/Master/WEB_M_WS_PumpStation_Delete`
    }

    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                // handleDeleteCloseClick()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)
                // handleDeleteCloseClick()
            }
            return result

        })
})

const WaterSupplyPumpStationMasterDeleteSlice = createSlice({
    name: "WaterSupplyPumpStationMasterDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterSupplyPumpStationMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WaterSupplyPumpStationMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;
            // toastSuccesss(action.payload.message)
        });
        builder.addCase(WaterSupplyPumpStationMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterSupplyPumpStationMasterDeleteReducer = WaterSupplyPumpStationMasterDeleteSlice.reducer